import { mapGetters } from "vuex";

const LayoutType = {
	File: "file",
	DanceToSchool: "d2s",
  Cross: "cross"
}

const DanceValues = [
  {  model: "outline", dance: "Lesson Outline / Objectives" },
  { model: "introduction", dance: "Introduction" },
  { model: "warm-up", dance: "Introduction and Warm-Up" },
  { model: "main-session", dance: "Exploration" },
  { model: "game-session", dance: "Composition and Performance" },
  {  model: "competition", dance: "Competition" },
  {  model: "performance", dance: "Performance" },
  {  model: "health", dance: "Health & Wellbeing" },
  {  model: "collaboration", dance: "Collaboration" },
  {  model: "conclusion", dance: "Cool Down" },
  {  model: "activities", dance: "Activities" },
];

const CrossValues = [
  {  model: "outline", cross: "Lesson Outcome" },
  { model: "introduction", cross: "Lesson Outline " },
  { model: "main-session", cross: "Lesson Slides" },
  {  model: "conclusion", cross: "Lesson Summary " },
];


export const lessonContentMixin = {
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    fieldList() {
      let values = this.settings.fieldDisplayList.filter((field) => {
        let filtered = true;
        filtered =
          field.used === true &&
          (field.popover === undefined || field.popover === false);
        // if (filtered) {
        //   if (this.layoutType == "file") {
        //     filtered = field.filebased == true;
        //   }
        // }

        return filtered;
      });
      return values;
    },
  },
  data() {
    return {
      layoutTypes: LayoutType,
    };
  },

    methods: {
        parseContent(section) {
            var parsed = this.getContent(section).replace(/(\\r)*\\n/g, "<br>");
      
            var greenRegexp = /\*\*green\*\*(.*?)\*\*green\*\*/g;
            var greenMatches = Array.from(parsed.matchAll(greenRegexp), (m) => m[0]);
            if (greenMatches.length > 0) {
              greenMatches.forEach((r) => {
                parsed = parsed.replace(r, "<span class='green'>" + r + "</span>");
              });
              parsed = parsed.replace(/\*\*green\*\*/g, "");
            }
      
            var blueRegexp = /\*\*blue\*\*(.*?)\*\*blue\*\*/g;
            var blueMatches = Array.from(parsed.matchAll(blueRegexp), (m) => m[0]);
            if (blueMatches.length > 0) {
              blueMatches.forEach((r) => {
                parsed = parsed.replace(r, "<span class='blue'>" + r + "</span>");
              });
              parsed = parsed.replace(/\*\*blue\*\*/g, "");
            }
      
            var redRegexp = /\*\*red\*\*(.*?)\*\*red\*\*/g;
            var redMatches = Array.from(parsed.matchAll(redRegexp), (m) => m[0]);
            if (redMatches.length > 0) {
              redMatches.forEach((r) => {
                parsed = parsed.replace(r, "<span class='red'>" + r + "</span>");
              });
              parsed = parsed.replace(/\*\*red\*\*/g, "");
            }
      
            return this.parseContentIcon(parsed).replace(/<p><br><\/p>/g, "");
          },
          parseContentIcon(content) {
            var parsed = content.replace(
              /\[\[icon_info-circle\]\]/g,
              '<i class="fas pr-1 fa-info-circle"></i>'
            );
            parsed = parsed.replace(
              /\[\[icon_camera\]\]/g,
              '<i class="fas pr-1 fa-camera"></i>'
            );
            parsed = parsed.replace(
              /\[\[icon_video\]\]/g,
              '<i class="fas pr-1 fa-video"></i>'
            );
      
            return parsed;
          },
          popupTitle(section) {
            return section === "outline" ? "Introduction" : "Additional Activities";
          },
          showTitle(section) {
            return section != "outline";
          },
          processContent(section, lesson, altered) {
            let vm = this
            var content = (function (field) {
              switch (field) {
                case "introduction":
                  let introduction = altered
                    ? altered.detail
                    : lesson.introduction;
                  return introduction != null
                    ? introduction + vm.getEquipment(lesson)
                    : "" + vm.getEquipment(lesson);
                case "warm-up":
                  let warmup = altered ? altered.detail : lesson.warmup;
                  return warmup != null ? warmup : "";
                case "game-session":
                  let game = altered ? altered.detail : lesson.gamecontent;
                  return game != null ? game : "";
                case "main-session":
                  let main = altered ? altered.detail : lesson.maincontent;
                  return main != null ? main : "";
                case "competition":
                  let competition = altered ? altered.detail : lesson.competition;
                  return competition != null ? competition : "";
                case "conclusion":
                  let conclusion = altered ? altered.detail : lesson.conclusion;
                  return conclusion != null ? conclusion : "";
                case "activities":
                  let activities = altered ? altered.detail : lesson.activities;
                  return activities != null ? activities : "";
                case "health":
                  let health = altered ? altered.detail : lesson.health;
                  return health != null ? health : "";
                case "performance":
                  let performance = altered ? altered.detail : lesson.performance;
                  return performance != null ? performance : "";
                case "collaboration":
                  let collaboration = altered
                    ? altered.detail
                    : lesson.collaboration;
                  return collaboration != null ? collaboration : "";
                default:
                  return lesson.outline != null ? lesson.outline : "";
              }
            })(section);
            return content;
          },
          getEquipment(lesson) {
            let content =
              `<hr class="py-2"/>
              <h2  class="pt-4 font-semibold text-sm">Lesson Equipment</h2>
              <p>` +
              (Boolean(lesson.equipment) ? lesson.equipment : "") +
              `</p>
              <h2 class="pt-4 font-semibold text-sm">Lesson Location</h2>
              <p>` +
              (Boolean(lesson.location) ? lesson.location : "") +
              `</p>`;
            return content;
          },
          processSectionTitle(subjectId, field, lesson, altered) {
            var title = this.fieldTitle(subjectId, field, lesson.layout)
            
            const marker = altered
              ? "<div class='h-4 w-4 bg-blue-500 pr-3 inline-block rounded-full'>&nbsp;</div> &nbsp"
              : "";
            return marker + "<div class='inline'>" + title + "</div>";
          },
          fieldTitle(subjectId, field, layout) {

            var title = field.value == undefined ? field.name : field.value;
            if (layout === LayoutType.DanceToSchool) {
              let danceField = DanceValues.find((v) =>  v.model === field.model )
              if (danceField != undefined) {
                title = danceField.dance
              }
            }

            if (subjectId != undefined && subjectId > 1) {
              let found = CrossValues.find((e) => e.model === field.model)
          
              if (found) {
                title = found.cross
              }
            }

            return title
          },
          navigationFieldList(subjectId) {
            var values = this.settings.fieldDisplayList.filter((field) => {
              return field.protect != true && field.used === true;
            });
      
            if (subjectId != undefined && subjectId > 1) {
              values = values.filter((field) => {
                return CrossValues.some((e) => e.model === field.model)
              })
            }
             
            return values;
          },
          
    }

}